export const PrettyName = {
    'more': 'Beweeg Meer',
    'smart': 'Beweeg Slim',
    'together': 'Beweeg Samen',
    'impulse': 'Beweeg Tussendoor',
}